import BulkEdit from '../components/BulkEdit';

const BulkEditContainer = BulkEdit;

export default BulkEditContainer;
